import { createFileRoute } from "@tanstack/react-router"
import { BackofficeCustomers } from "modules/backoffice/components/customers"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { CustomersFilterBySchema, CustomersSortSchema } from "schema"
import { z } from "zod"

const SearchBackofficeCustomersSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(CustomersSortSchema.shape.sortBy.unwrap())
  .merge(CustomersFilterBySchema)

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list",
)({
  component: BackofficeCustomers,
  validateSearch: (search: Partial<z.infer<typeof SearchBackofficeCustomersSchema>>) => {
    search.filterBy = search.filterBy || {}
    return SearchBackofficeCustomersSchema.parse(search)
  },
})
